<div class="flex items-center">
	<div class="z-10 flex items-center space-x-2">
		<ng-container
			*ngTemplateOutlet="
        mode === 'range'
          ? rangeModeTemplate
          : mode === 'range_optional'
            ? stateVisibleMode
              ? rangeModeTemplate
              : durationModeTemplate
            : mode === 'duration'
              ? durationModeTemplate
              : null
      "
		></ng-container>
		<div
			[class.mat-bg]="!showMenu?.value"
			class="flex h-12 flex-shrink-0 cursor-default items-center rounded-lg px-2.5"
			tabindex="0"
		>
			<div class="flex flex-1 flex-col">
				<ng-container *ngIf="controlValue$.value$ | async as value">
					<div
						*ngIf="!mode || mode === 'range' || (mode === 'range_optional' && stateVisibleMode)"
						class="text-center font-semibold leading-none"
					>
						{{
							(mode !== 'duration' ? value.rangeDuration : value.duration) ?? 0 | parseMsAsDuration: false
						}}
					</div>
					<div
						*ngIf="value?.date as date"
						class="mat-hint mt-0.5 leading-none"
					>
						{{ date | formatDate }}
					</div>
				</ng-container>
			</div>
		</div>
		<ng-container *ngTemplateOutlet="mode === 'range_optional' ? modeToggle : null"></ng-container>
	</div>
	<div
		@matScale
		*ngIf="showMenu?.value"
		class="mbg-card absolute inset-x-0 top-0 -mx-1.5 -mt-1.5 rounded-lg"
		tabindex="-1"
	>
		<div class="h-16"></div>
		<mat-divider></mat-divider>
		<div
			class="flex flex-1 flex-col"
			tabindex="-1"
		>
			<mat-calendar
				(selectedChange)="updateDate($event)"
				[dateFilter]="availableDates"
				[selected]="controlValue.date"
				[startAt]="controlValue.date"
				class="-mt-4"
				color="primary"
				tabindex="-1"
			></mat-calendar>
		</div>
		<div class="h-6"></div>
	</div>
</div>
<ng-template #noTimeValue> <div>00:00</div> </ng-template>
<mat-menu #timeContextMenuTimeTemplates="matMenu">
	<ng-template
		let-data
		matMenuContent
	>
		<button
			(click)="setMinutesDiff(5, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 5 } }}
		</button>
		<button
			(click)="setMinutesDiff(10, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 10 } }}
		</button>
		<button
			(click)="setMinutesDiff(15, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 15 } }}
		</button>
		<button
			(click)="setMinutesDiff(30, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 30 } }}
		</button>
		<button
			(click)="setHourDiff(1, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.HrDiff' | translate: { value: 1 } }}
		</button>
		<button
			(click)="setHourDiff(2, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.HrDiffs' | translate: { value: 2 } }}
		</button>
		<button
			(click)="setHourDiff(4, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.HrDiffs' | translate: { value: 4 } }}
		</button>
		<button
			(click)="setWorkDay()"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.1workDay' | translate }}
		</button>
	</ng-template>
</mat-menu>
<mat-menu #timeContextMenu="matMenu">
	<ng-template
		let-data
		matMenuContent
	>
		<button
			(click)="setToNow(data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.now' | translate }}
		</button>
		<button
			[matMenuTriggerData]="{ $implicit: data }"
			[matMenuTriggerFor]="timeContextMenuTimeTemplates"
			mat-menu-item
		>
			{{ 'timeContextMenu.setToMore' | translate }}
		</button>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="timeContextMenu"
	[style.left]="timeContextMenuPosition.x"
	[style.top]="timeContextMenuPosition.y"
	#timeContextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<ng-template #startEndTemplate>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="control"
		#timespanRef
		class="flex flex-row items-center justify-start gap-[10px]"
	>
		<div class="w-[86px] flex-shrink-0 pb-0">
			<app-time-input
				[displayFormat]="false"
				formControlName="start"
				placeholder="00:00"
			>
				<ng-template
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					let-placeholder="placeholder"
					timeInputControl
				>
					<mat-form-field
						[matTooltip]="inputPlaceholder | translate"
						appearance="fill"
						class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
						fxFill
					>
						<input
							[attr.placeholder]="placeholder"
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</app-time-input>
		</div>
		<mat-icon inline>arrow_forward</mat-icon>
		<div class="w-[86px] flex-shrink-0 pb-0">
			<app-time-input
				[displayFormat]="false"
				formControlName="end"
				placeholder="00:00"
			>
				<ng-template
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					let-placeholder="placeholder"
					timeInputControl
				>
					<mat-form-field
						[matTooltip]="inputPlaceholder | translate"
						appearance="fill"
						class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
						fxFill
					>
						<input
							[attr.placeholder]="placeholder"
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</app-time-input>
		</div>
	</form>
</ng-template>
<ng-template #rangeModeTemplate> <ng-container *ngTemplateOutlet="startEndTemplate"></ng-container> </ng-template>
<ng-template #rangeOptModeTemplate>
	<ng-container *ngTemplateOutlet="startEndTemplate"></ng-container>
	<ng-container *ngTemplateOutlet="durationModeTemplate"></ng-container>
</ng-template>
<ng-template #durationModeTemplate>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="control"
		#timespanRef
		class="flex flex-row items-center justify-start gap-[10px]"
	>
		<div class="w-[86px] flex-shrink-0 pb-0">
			<tg-duration-input-control
				displayFormat="HH:mm"
				formControlName="duration"
				inputPlaceholder="timer.time.duration"
				placeholder="00:00"
			>
				<ng-template
					durationInputControl
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					let-placeholder="placeholder"
				>
					<mat-form-field
						[matTooltip]="inputPlaceholder | translate"
						appearance="fill"
						class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
						fxFill
					>
						<input
							[attr.placeholder]="placeholder"
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</tg-duration-input-control>
		</div>
	</form>
</ng-template>
<ng-template #modeToggle>
	<button
		(click)="toggleStateVisibleMode()"
		[matTooltip]="'timer.time.changeInputMode' | translate"
		mat-icon-button
		type="button"
	>
		<mat-icon>swap_horiz</mat-icon>
	</button>
</ng-template>
